/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_init = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');
		
		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);

		/*
		Loading: Pause
		*/
		specific_loader.loading(0);
		
		/*
		Catch and active URL
		*/
		specific_interactions.catchAndActiveURL();

		/*
		Init: Firstlogin or Reservation
		*/
		if($('.firstlogin').length == 1) {
			
			specific_firstlogin.onready();

		} else {

			/*
			Onready
			*/
			if(url[2] == 'information') {
				specific_booking_information.onready();
			}
			if(url[2] == 'messages') {
				specific_booking_messages.onready();
			}
			if(url[2] == 'payments') {
				specific_booking_payments.onready();
			}

		}

		/*
		Init: Telephone
		*/
		if($('.js-form-input-telephone_iti').length > 0) {

			input = document.querySelector(".js-form-input-telephone_iti");
			
			iti = window.intlTelInput(input,{
				
				separateDialCode	: true,
				fixDropdownWidth 	: false,
				formatAsYouType 	: false,
				
				utilsScript			: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.1.0/build/js/utils.js',

				initialCountry: "auto",
				geoIpLookup: function(success, failure) {
					fetch("https://ipapi.co/json")
					.then(function(res) { return res.json(); })
					.then(function(data) { success(data.country_code); })
					.catch(function() { failure(); });
				}

			});

		}

		/*
		Content scroll: Check for images preload
		*/
		$('.js-content-scroller').on('scroll', function() {
			setTimeout(function() {
				images.preload();
			}, 200);
		});

		/*
		Residence Information
		*/
		if(
			url[2] == 'residence-information'
		) {

			/*
			SimpleLightbox
			*/
			$('.js-lightboxgallery a').simpleLightbox({
				history: false,
				overlayOpacity:0.9
			});
			
		}

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_init); 
